import * as THREE from 'three';

export function generateBinShell(dimensions, { binMaterial }) {
  const meshPoints = { top: [], body: [], bottom: [] };

  const rectanglePointTuples = [
    [1, 1],
    [0, 1],
    [0, 0],
    [1, 0],
  ];
  const bodyTop = 0; /* m */
  const bodyBottom = -dimensions.body.height; /* m */
  const hopperBottom = -dimensions.totalHeight; /* m */

  const hopperWidthOffset = dimensions.hopper.leftOffset;
  const hopperDepthOffset = dimensions.hopper.frontOffset;

  for (let tupleIndex = 0; tupleIndex < rectanglePointTuples.length; tupleIndex++) {
    const [xOffset, yOffset] = rectanglePointTuples[tupleIndex];
    const [nextXOffset, nextYOffset] = rectanglePointTuples[(tupleIndex + 1) % rectanglePointTuples.length];

    const xBody = dimensions.body.width * xOffset;
    const yBody = dimensions.body.depth * yOffset;
    const xBodyNext = dimensions.body.width * nextXOffset;
    const yBodyNext = dimensions.body.depth * nextYOffset;

    const xHopper = dimensions.hopper.width * xOffset;
    const yHopper = dimensions.hopper.depth * yOffset;
    const xHopperNext = dimensions.hopper.width * rectanglePointTuples[(tupleIndex + 1) % rectanglePointTuples.length][0];
    const yHopperNext = dimensions.hopper.depth * rectanglePointTuples[(tupleIndex + 1) % rectanglePointTuples.length][1];

    // Body
    meshPoints.body.push(xBody, yBody, bodyTop);
    meshPoints.body.push(xBody, yBody, bodyBottom);
    meshPoints.body.push(xBodyNext, yBodyNext, bodyTop);

    meshPoints.body.push(xBodyNext, yBodyNext, bodyBottom);
    meshPoints.body.push(xBodyNext, yBodyNext, bodyTop);
    meshPoints.body.push(xBody, yBody, bodyBottom);

    // Hopper
    meshPoints.bottom.push(xBody, yBody, bodyBottom);
    meshPoints.bottom.push(xHopperNext + hopperWidthOffset, yHopperNext + hopperDepthOffset, hopperBottom);
    meshPoints.bottom.push(xBodyNext, yBodyNext, bodyBottom);

    meshPoints.bottom.push(xHopperNext + hopperWidthOffset, yHopperNext + hopperDepthOffset, hopperBottom);
    meshPoints.bottom.push(xBody, yBody, bodyBottom);
    meshPoints.bottom.push(xHopper + hopperWidthOffset, yHopper + hopperDepthOffset, hopperBottom);
  }

  // Generate a plane to close the top
  meshPoints.top.push(dimensions.body.width * rectanglePointTuples[0][0], dimensions.body.depth * rectanglePointTuples[0][1], bodyTop);
  meshPoints.top.push(dimensions.body.width * rectanglePointTuples[1][0], dimensions.body.depth * rectanglePointTuples[1][1], bodyTop);
  meshPoints.top.push(dimensions.body.width * rectanglePointTuples[2][0], dimensions.body.depth * rectanglePointTuples[2][1], bodyTop);

  meshPoints.top.push(dimensions.body.width * rectanglePointTuples[2][0], dimensions.body.depth * rectanglePointTuples[2][1], bodyTop);
  meshPoints.top.push(dimensions.body.width * rectanglePointTuples[3][0], dimensions.body.depth * rectanglePointTuples[3][1], bodyTop);
  meshPoints.top.push(dimensions.body.width * rectanglePointTuples[0][0], dimensions.body.depth * rectanglePointTuples[0][1], bodyTop);

  const buffGeometry = new THREE.BufferGeometry();
  buffGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(meshPoints.top), 3));
  buffGeometry.computeVertexNormals();
  const meshTop = new THREE.Mesh(buffGeometry, binMaterial);
  meshTop.receiveShadow = true;
  meshTop.castShadow = true;

  const buffGeometry3 = new THREE.BufferGeometry();
  buffGeometry3.setAttribute('position', new THREE.BufferAttribute(new Float32Array(meshPoints.body), 3));
  buffGeometry3.computeVertexNormals();
  const meshBody = new THREE.Mesh(buffGeometry3, binMaterial);
  meshBody.receiveShadow = true;
  meshBody.castShadow = true;

  const buffGeometry2 = new THREE.BufferGeometry();
  buffGeometry2.setAttribute('position', new THREE.BufferAttribute(new Float32Array(meshPoints.bottom), 3));
  buffGeometry2.computeVertexNormals();
  const meshBottom = new THREE.Mesh(buffGeometry2, binMaterial);
  meshBottom.receiveShadow = true;
  meshBottom.castShadow = true;

  return [
    meshTop,
    meshBody,
    meshBottom,
  ];
}
